'use client';
import React, { useEffect, useRef, useState } from 'react';
import Link from 'next/link';

const ecosystemItems = [
  {
    label: 'Resource Vault',
    description: 'Ebooks, audio guides, and worksheets — curated for each stage of your journey.',
    href: '/resource-vault',
    tag: 'Enrolled Students',
  },
  {
    label: 'Talk to Uni',
    description: 'A private community for reflection, gratitude, and healing wins. Intimate and purposeful.',
    href: '/community',
    tag: 'Community',
  },
  {
    label: 'Progress Tracking',
    description: 'Your journey mapped — lesson by lesson. Know exactly where you are.',
    href: '/student-dashboard',
    tag: 'Dashboard',
  },
  {
    label: 'Certificate',
    description: 'Complete the Transformation Mastery program and receive a certificate of your journey.',
    href: '/transformation-mastery',
    tag: 'Mastery Program',
  },
  {
    label: 'Physical Healing Book',
    description: 'A curated physical guide delivered to your door — a tangible companion to your digital journey.',
    href: '/transformation-mastery',
    tag: 'Mastery Program',
  },
];

export default function EcosystemScene() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [headerVisible, setHeaderVisible] = useState(false);
  const [itemVisible, setItemVisible] = useState<boolean[]>([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setHeaderVisible(true);
            ecosystemItems.forEach((_, i) => {
              setTimeout(() => {
                setItemVisible(prev => {
                  const next = [...prev];
                  next[i] = true;
                  return next;
                });
              }, 100 + i * 110);
            });
          }
        });
      },
      { threshold: 0.08 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section data-component-id="src/app/homepage/components/EcosystemScene.tsx:68:4" data-component-path="src/app/homepage/components/EcosystemScene.tsx" data-component-line="68" data-component-end-line="209" data-component-file="EcosystemScene.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22className%22%3A%22relative%20overflow-hidden%22%7D"
      ref={sectionRef}
      className="relative overflow-hidden"
      style={{
        background: '#F4EFE6',
        paddingTop: 'clamp(6rem, 14vw, 11rem)',
        paddingBottom: 'clamp(6rem, 14vw, 11rem)',
      }}
    >
      {/* Pale Mist grain */}
      <div data-component-id="src/app/homepage/components/EcosystemScene.tsx:78:6" data-component-path="src/app/homepage/components/EcosystemScene.tsx" data-component-line="78" data-component-end-line="84" data-component-file="EcosystemScene.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20inset-0%20pointer-events-none%20opacity-%5B0.016%5D%22%7D"
        className="absolute inset-0 pointer-events-none opacity-[0.016]"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)' opacity='1'/%3E%3C/svg%3E")`,
          backgroundSize: '128px 128px',
        }}
      />

      {/* Botanical watermark — left side */}
      <div data-component-id="src/app/homepage/components/EcosystemScene.tsx:87:6" data-component-path="src/app/homepage/components/EcosystemScene.tsx" data-component-line="87" data-component-end-line="95" data-component-file="EcosystemScene.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20left-0%20bottom-0%20pointer-events-none%20opacity-%5B0.06%5D%22%7D" className="absolute left-0 bottom-0 pointer-events-none opacity-[0.06]" aria-hidden="true">
        <svg data-component-id="src/app/homepage/components/EcosystemScene.tsx:88:8" data-component-path="src/app/homepage/components/EcosystemScene.tsx" data-component-line="88" data-component-end-line="94" data-component-file="EcosystemScene.tsx" data-component-name="svg" data-component-content="%7B%22elementName%22%3A%22svg%22%7D" width="300" height="400" viewBox="0 0 300 400" fill="none">
          <path data-component-id="src/app/homepage/components/EcosystemScene.tsx:89:10" data-component-path="src/app/homepage/components/EcosystemScene.tsx" data-component-line="89" data-component-end-line="89" data-component-file="EcosystemScene.tsx" data-component-name="path" data-component-content="%7B%22elementName%22%3A%22path%22%7D" d="M150 390 Q130 320 110 250 Q90 180 130 120 Q170 60 150 20" stroke="#3A7A5A" strokeWidth="1" fill="none"/>
          <path data-component-id="src/app/homepage/components/EcosystemScene.tsx:90:10" data-component-path="src/app/homepage/components/EcosystemScene.tsx" data-component-line="90" data-component-end-line="90" data-component-file="EcosystemScene.tsx" data-component-name="path" data-component-content="%7B%22elementName%22%3A%22path%22%7D" d="M150 280 Q110 260 90 230 Q70 200 95 175" stroke="#3A7A5A" strokeWidth="0.8" fill="none"/>
          <path data-component-id="src/app/homepage/components/EcosystemScene.tsx:91:10" data-component-path="src/app/homepage/components/EcosystemScene.tsx" data-component-line="91" data-component-end-line="91" data-component-file="EcosystemScene.tsx" data-component-name="path" data-component-content="%7B%22elementName%22%3A%22path%22%7D" d="M150 240 Q190 220 210 190 Q230 160 205 135" stroke="#3A7A5A" strokeWidth="0.8" fill="none"/>
          <ellipse data-component-id="src/app/homepage/components/EcosystemScene.tsx:92:10" data-component-path="src/app/homepage/components/EcosystemScene.tsx" data-component-line="92" data-component-end-line="92" data-component-file="EcosystemScene.tsx" data-component-name="ellipse" data-component-content="%7B%22elementName%22%3A%22ellipse%22%7D" cx="90" cy="175" rx="25" ry="15" stroke="#3A7A5A" strokeWidth="0.8" transform="rotate(-25 90 175)"/>
          <ellipse data-component-id="src/app/homepage/components/EcosystemScene.tsx:93:10" data-component-path="src/app/homepage/components/EcosystemScene.tsx" data-component-line="93" data-component-end-line="93" data-component-file="EcosystemScene.tsx" data-component-name="ellipse" data-component-content="%7B%22elementName%22%3A%22ellipse%22%7D" cx="205" cy="135" rx="25" ry="15" stroke="#3A7A5A" strokeWidth="0.8" transform="rotate(25 205 135)"/>
        </svg>
      </div>

      <div data-component-id="src/app/homepage/components/EcosystemScene.tsx:97:6" data-component-path="src/app/homepage/components/EcosystemScene.tsx" data-component-line="97" data-component-end-line="208" data-component-file="EcosystemScene.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22editorial-container%20relative%20z-10%22%7D" className="editorial-container relative z-10">
        {/* Header */}
        <div data-component-id="src/app/homepage/components/EcosystemScene.tsx:99:8" data-component-path="src/app/homepage/components/EcosystemScene.tsx" data-component-line="99" data-component-end-line="127" data-component-file="EcosystemScene.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-center%20mb-20%20lg%3Amb-28%22%7D"
          className="text-center mb-20 lg:mb-28"
          style={{
            opacity: headerVisible ? 1 : 0,
            transform: headerVisible ? 'translateY(0)' : 'translateY(20px)',
            transition: 'opacity 1s ease, transform 1s ease',
          }}
        >
          <p data-component-id="src/app/homepage/components/EcosystemScene.tsx:107:10" data-component-path="src/app/homepage/components/EcosystemScene.tsx" data-component-line="107" data-component-end-line="112" data-component-file="EcosystemScene.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-xs%20font-sans%20uppercase%20tracking-%5B0.2em%5D%20mb-10%20inline-block%22%2C%22textContent%22%3A%22The%20Ecosystem%22%7D"
            className="text-xs font-sans uppercase tracking-[0.2em] mb-10 inline-block"
            style={{ color: '#3A7A5A', fontWeight: 600 }}
          >
            The Ecosystem
          </p>
          <h2 data-component-id="src/app/homepage/components/EcosystemScene.tsx:113:10" data-component-path="src/app/homepage/components/EcosystemScene.tsx" data-component-line="113" data-component-end-line="126" data-component-file="EcosystemScene.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22font-serif%20text-balance%20mx-auto%22%2C%22textContent%22%3A%22Everything%20you%20need%22%7D"
            className="font-serif text-balance mx-auto"
            style={{
              fontSize: 'clamp(2.2rem, 5vw, 4rem)',
              color: '#1A6B6B',
              lineHeight: 1.05,
              fontWeight: 300,
              letterSpacing: '0.04em',
              maxWidth: '20ch',
            }}
          >
            Everything you need<br data-component-id="src/app/homepage/components/EcosystemScene.tsx:124:31" data-component-path="src/app/homepage/components/EcosystemScene.tsx" data-component-line="124" data-component-end-line="124" data-component-file="EcosystemScene.tsx" data-component-name="br" data-component-content="%7B%22elementName%22%3A%22br%22%7D" />
            <span data-component-id="src/app/homepage/components/EcosystemScene.tsx:125:12" data-component-path="src/app/homepage/components/EcosystemScene.tsx" data-component-line="125" data-component-end-line="125" data-component-file="EcosystemScene.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22textContent%22%3A%22to%20heal%20%E2%80%94%20in%20one%20place.%22%7D" style={{ color: 'rgba(26,107,107,0.25)' }}>to heal — in one place.</span>
          </h2>
        </div>

        {/* Ecosystem list */}
        <div data-component-id="src/app/homepage/components/EcosystemScene.tsx:130:8" data-component-path="src/app/homepage/components/EcosystemScene.tsx" data-component-line="130" data-component-end-line="207" data-component-file="EcosystemScene.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" style={{ borderTop: '1px solid rgba(26,107,107,0.1)' }}>
          {ecosystemItems?.map((item, i) => (
            <Link data-component-id="src/app/homepage/components/EcosystemScene.tsx:132:12" data-component-path="src/app/homepage/components/EcosystemScene.tsx" data-component-line="132" data-component-end-line="205" data-component-file="EcosystemScene.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22className%22%3A%22grid%20grid-cols-1%20lg%3Agrid-cols-12%20gap-0%20block%22%7D"
              key={item?.label}
              href={item?.href}
              className="grid grid-cols-1 lg:grid-cols-12 gap-0 block"
              style={{
                borderBottom: '1px solid rgba(26,107,107,0.1)',
                opacity: itemVisible[i] ? 1 : 0,
                transform: itemVisible[i] ? 'translateY(0)' : 'translateY(14px)',
                transition: `opacity 0.7s ease, transform 0.7s ease, background 0.25s ease`,
                textDecoration: 'none',
              }}
              onMouseEnter={e => {
                (e.currentTarget as HTMLElement).style.background = 'rgba(168,216,206,0.12)';
              }}
              onMouseLeave={e => {
                (e.currentTarget as HTMLElement).style.background = 'transparent';
              }}
            >
              <div data-component-id="src/app/homepage/components/EcosystemScene.tsx:150:14" data-component-path="src/app/homepage/components/EcosystemScene.tsx" data-component-line="150" data-component-end-line="168" data-component-file="EcosystemScene.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22lg%3Acol-span-4%20py-8%20lg%3Apy-10%22%7D" className="lg:col-span-4 py-8 lg:py-10">
                <h3 data-component-id="src/app/homepage/components/EcosystemScene.tsx:151:16" data-component-path="src/app/homepage/components/EcosystemScene.tsx" data-component-line="151" data-component-end-line="161" data-component-file="EcosystemScene.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22font-serif%22%7D"
                  className="font-serif"
                  style={{
                    fontSize: 'clamp(1.1rem, 1.8vw, 1.5rem)',
                    color: '#1A6B6B',
                    fontWeight: 300,
                    letterSpacing: '0.04em',
                  }}
                >
                  {item?.label}
                </h3>
                <p data-component-id="src/app/homepage/components/EcosystemScene.tsx:162:16" data-component-path="src/app/homepage/components/EcosystemScene.tsx" data-component-line="162" data-component-end-line="167" data-component-file="EcosystemScene.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-xs%20font-sans%20uppercase%20tracking-widest%20mt-1%22%7D"
                  className="text-xs font-sans uppercase tracking-widest mt-1"
                  style={{ color: 'rgba(26,107,107,0.35)', fontWeight: 600 }}
                >
                  {item?.tag}
                </p>
              </div>
              <div data-component-id="src/app/homepage/components/EcosystemScene.tsx:169:14" data-component-path="src/app/homepage/components/EcosystemScene.tsx" data-component-line="169" data-component-end-line="204" data-component-file="EcosystemScene.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22lg%3Acol-span-7%20lg%3Acol-start-6%20py-8%20lg%3Apy-10%20flex%20items-center%20justify-between%22%7D"
                className="lg:col-span-7 lg:col-start-6 py-8 lg:py-10 flex items-center justify-between"
                style={{ borderLeft: '1px solid rgba(26,107,107,0.08)' }}
              >
                <p data-component-id="src/app/homepage/components/EcosystemScene.tsx:173:16" data-component-path="src/app/homepage/components/EcosystemScene.tsx" data-component-line="173" data-component-end-line="178" data-component-file="EcosystemScene.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22font-sans%20font-light%20leading-relaxed%20max-w-%5B50ch%5D%20lg%3Apl-12%22%7D"
                  className="font-sans font-light leading-relaxed max-w-[50ch] lg:pl-12"
                  style={{ fontSize: '0.875rem', color: 'rgba(36,44,44,0.45)', fontWeight: 300 }}
                >
                  {item?.description}
                </p>
                <span data-component-id="src/app/homepage/components/EcosystemScene.tsx:179:16" data-component-path="src/app/homepage/components/EcosystemScene.tsx" data-component-line="179" data-component-end-line="203" data-component-file="EcosystemScene.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22hidden%20lg%3Ablock%20ml-8%20text-sm%20font-sans%22%2C%22textContent%22%3A%22%E2%86%92%22%7D"
                  className="hidden lg:block ml-8 text-sm font-sans"
                  style={{
                    color: 'rgba(26,107,107,0.25)',
                    display: 'inline-block',
                    transition: 'transform 0.22s ease, color 0.22s ease',
                  }}
                  ref={el => {
                    if (!el) return;
                    const parent = el.closest('a');
                    if (!parent) return;
                    const enter = () => {
                      el.style.transform = 'translateX(5px)';
                      el.style.color = '#1A6B6B';
                    };
                    const leave = () => {
                      el.style.transform = 'translateX(0)';
                      el.style.color = 'rgba(26,107,107,0.25)';
                    };
                    parent.addEventListener('mouseenter', enter);
                    parent.addEventListener('mouseleave', leave);
                  }}
                >
                  →
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
